import { Box, Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { MoreVert } from "@mui/icons-material";
import { StyledSeperator } from "./Seperator";
import { useServiceDrawer } from "../features/returns/useServiceDrawer";
import ReturnsTagModal from "../modals/ReturnsTagModal";
import { downloadAwb, bookReturnsMethod } from "../features/returns/returnApi";
import toast from "react-hot-toast";
import { StyledButton } from "./StyledButton";
import { useNavigate } from "react-router-dom";
import { MoreVertIcon } from "../../common/iconsData";

export const ReturnsEditButton = ({
  id,
  status,
  vendor,
  showBook,
}: {
  id: string | number;
  status?: string;
  vendor?: string;
  showBook: "book" | "vertical" | "both";
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const reassignReturnsHandler = () => {
    onOpen(id);
    handleClose();
  };

  const { onOpen, onOpenCancel, setSyncReturns } =
    useServiceDrawer();

  const handleCancelRetruns = () => {
    onOpenCancel(id);
    handleClose();
  };

  const downloadAwbHandler = () => {
    downloadAwb(id)
      .then((data) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(data.data);
        downloadLink.download = `returns_${id}_awb.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        handleClose();
      })
      .catch(console.log);
  };


  const navigate = useNavigate();
  const EditReturn = () => {
    navigate(`/returns/edit-returns?return_id=${id}`);
  };

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={2}
      >
        {showBook === "book" && (
          <BookButton
            id={id}
            status={status as string}
            vendor={vendor as string}
          />
        )}

        {showBook === "vertical" && (
          <VerticalButton handleClick={handleClick} />
        )}

        {showBook === "both" && (
          <>
            <BookButton
              id={id}
              status={status as string}
              vendor={vendor as string}
            />
            <VerticalButton handleClick={handleClick} />
          </>
        )}
      </Stack>
      {/* {status && status === "ready_to_ship" && vendor !== null && (
        <StyledButton variant="contained" onClick={bookReturns}>
          <Typography textTransform={"none"} fontSize={12}>
            Book Now
          </Typography>
        </StyledButton>
      )}
      {status && status === "booked" && (
        <StyledButton
          size="small"
          variant="contained"
          onClick={() => onOpenSchedule(id)}
        >
          <Typography textTransform={"none"} fontSize={12}>
            schedule now
          </Typography>
        </StyledButton>
      )}
      <Button onClick={handleClick}>
        <MoreVert
          sx={{
            fontSize: "16px",
          }}
        />
      </Button> */}
      <Menu
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box>
          {status && status !== "ready_to_ship" && (
            <>
              <MenuItem onClick={handleClose}>
                <Typography fontSize={12}>
                  Download pro-forma Invoice
                </Typography>
              </MenuItem>
              {/* <MenuItem onClick={handleClose}>
                <Typography fontSize={12}>Download Prov Invoice</Typography>
              </MenuItem> */}
              <MenuItem onClick={downloadAwbHandler}>
                <Typography fontSize={12}>Download Awb</Typography>
              </MenuItem>
              <StyledSeperator
                style={{
                  margin: "0 12px",
                }}
              />
            </>
          )}
          {status && status !== "cancelled" && (
            <>
              <MenuItem onClick={EditReturn}>
                <Typography fontSize={12}>Edit Returns</Typography>
              </MenuItem>
              {vendor && vendor !== null && (
                <MenuItem onClick={reassignReturnsHandler}>
                  <Typography fontSize={12}>Reassign Returns</Typography>
                </MenuItem>
              )}
              <StyledSeperator
                style={{
                  margin: "0 12px",
                }}
              />
              <MenuItem
                onClick={() => {
                  setModalOpen(true);
                  handleClose();
                }}
              >
                <Typography fontSize={12}>Add Returns Tag</Typography>
              </MenuItem>
              {/* <MenuItem onClick={handleClose}>
                <Typography fontSize={12}>Clone Returns</Typography>
              </MenuItem> */}

              {status !== "delivered" && (
                <MenuItem onClick={handleCancelRetruns}>
                  <Typography fontSize={12} color={"red"}>
                    Cancel Returns
                  </Typography>
                </MenuItem>
              )}
            </>
          )}
        </Box>
      </Menu>

      <ReturnsTagModal
        id={id}
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
      />
    </>
  );
};

const BookButton = ({
  status,
  vendor,
  id,
}: {
  status: string;
  vendor: null | string;
  id: string | number;
}) => {
  const { onOpen, onOpenSchedule, setSyncReturns } = useServiceDrawer();

  const bookReturns = () => {
    bookReturnsMethod([`${id}`])
      .then((data) => {
        toast.success("Return booked");
        setSyncReturns();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {status && status === "ready_to_ship" && vendor === null && (
        <StyledButton
          size="small"
          variant="contained"
          onClick={() => {
            onOpen(id);
          }}
        >
          <Typography textTransform={"none"} fontSize={12}>
            Ship Now
          </Typography>
        </StyledButton>
      )}

      {status && status === "ready_to_ship" && vendor !== null && (
        <StyledButton variant="contained" onClick={bookReturns}>
          <Typography textTransform={"none"} fontSize={12}>
            Book Now
          </Typography>
        </StyledButton>
      )}
      {status && status === "booked" && (
        <StyledButton
          variant="contained"
          size="small"
          onClick={() => onOpenSchedule(id)}
        >
          <Typography textTransform={"none"} fontSize={12}>
            schedule now
          </Typography>
        </StyledButton>
      )}
    </>
  );
};


const VerticalButton = ({
  handleClick,
}: {
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
}) => {
  return (
    <Button
      sx={{
        minWidth: "0",
        padding: "0 0",
      }}
      onClick={handleClick}
    >
      <MoreVertIcon
        sx={{
          fontSize: "16px",
        }}
      />
    </Button>
  );
};
